// Custom return function for the the react-markdown parser.
// rest.children.props only exists if there is extra html to parse inside the code block.
// We do not want to allow nested code blocks, so if there is nested html, return it in a <span>
// For all other clode blocks, return the block with an additional button that copies to clipboard

import React, { ClassAttributes, DetailedHTMLProps, HTMLAttributes } from 'react'
import { ExtraProps } from 'react-markdown'

export default function codeBlock(
    props: ClassAttributes<HTMLElement> &
        HTMLAttributes<HTMLElement> &
        ExtraProps
) {
    const { node, ...rest } = props
    return (
        <div className='codeWrapper' onClick={() =>
            copyText(rest.children as string | React.ReactElement[])
        }>
            <pre {...rest as DetailedHTMLProps<HTMLAttributes<HTMLPreElement>, HTMLPreElement>} ></pre>
            <div className='copyButtonWrapper' >
                <button
                    className="copyButton"
                >
                    <img src='/icons/copy.png' alt="copy" />
                </button>
            </div>
        </div>
    )
}

async function copyText(data: string | React.ReactElement[] | any) {
    if (typeof data === 'string') {
        await navigator.clipboard.writeText(data)
        return
    }

    if(data.props && data.props.children && typeof data.props.children==='string') {
        await navigator.clipboard.writeText(data.props.children)
        return
    }
    let toCopy = ''
    data.forEach((element: string | any) => {
        if (typeof element === 'string') {
            toCopy += element
        } else {
            toCopy += '\n'
        }
    })

    await navigator.clipboard.writeText(toCopy)
}
